<!-- eslint-disable -->
<template lang="pug">
    .play-box(:class="{'play-box_limited': !areQuestionsShown}")
        template(v-if="!isLoading")
            game-preparation-counter(v-if="!gameStarted && isGameTuned && counter" :counter="counter")
            template(v-else="")
                game-header(
                    @soundStateChanged="headerKey = !headerKey",
                    :key="headerKey",
                    :time='getTime'
                    :slug="type"
                    :game-type="parameters && parameters.courseType"
                    :is-homework="!!exerciseId"
                )
                .play-box__game(v-if="gameStarted && !gameFinished || !isGameTuned")
                    .play-box__example(:class="{'play-box__example--answers': areQuestionsShown}")
                        .play-box__header(v-if="isGameTuned")
                            .play-box__title
                                | {{ !areQuestionsShown ? $i18n.t('trainer.trainer_gamePlayBox_startReading') : $i18n.t('trainer.trainer_gamePlayBox_chooseCorrectAnswer') }}
                        scaling-bar(
                            v-if="!isGameTuned"
                            @doneWithPreparing="doneWithPreparing"
                            @setFontSize="setFontSize"
                            :is-game-tuned="isGameTuned"
                            :font-size="fontSize"
                            element-name="play-box__field"
                            :inverted-word="parameters && parameters.settings.invertText"
                        )
                        .play-box__buttons.play-box__buttons--game(v-if="isSlowDownAvailable")
                            cs-button.play-box__button(@click='slowDownGame')
                                | {{ $i18n.t('trainer.trainer_game_noTime') }}
                        .play-box__buttons.play-box__buttons--game(v-if="isGameTuned && !areQuestionsShown && parameters.mode === 'static'")
                            cs-button.play-box__button(color="blue", @click='showQuestions')
                                | {{ $i18n.t('trainer.trainer_gamePlayBox_textIsRead') }}
                        .play-box__overflow-container(v-if="!areQuestionsShown && isGameTuned")
                            .play-box__field(
                                :style="{fontSize: fontSize + 'px', lineHeight: (+fontSize + 10) + 'px'}"
                                :class="{\
                                    'play-box__field--appear-mode': parameters.mode === 'appear',\
                                    'play-box__field--inverted-text': parameters.settings.invertText\
                                }"
                            )
                                .play-box__header.game-text(ref="text-header")
                                    | {{ textLabel }}
                                div(
                                    v-if="parameters.mode === 'static'",
                                    v-for="line in lines(text)",
                                    :class="{'play-box__field_one-lined-text': parameters && parameters.settings.solidText}",
                                    :style="textContainerStyle"
                                ) {{ line }}
                                div(v-if="parameters.mode === 'appear'")
                                    span(v-for="item in textElements", :key="item", v-text="item")
                                div(v-if="parameters.mode === 'disappear'")
                                    span.game-text(
                                        v-for="item in textElements",
                                        :class="{ 'game-text_hidden': !item.enabled }",
                                        :key="item.id",
                                        v-text="item.content"
                                    )
                        .play-box__field.play-box__field--answers(v-if="areQuestionsShown" :key="shownGroup")
                            .play-box__question(v-for="(question, index) in questionsGroups[shownGroup - 1]" :key="index")
                                .question__content(v-text="question.content")
                                .question__answer(v-for="answer in question.answers")
                                    cs-checkbox(:checked="answer.selected", @change="setAnswer(answer, index)")
                                        span.answer__content(v-text="answer.content")
                        .play-box__field-bottom-container(v-if='areQuestionsShown')
                            pagination(
                                v-if="parameters.settings.allQuestions"
                                :is-data-from-query="false"
                                :current-page="shownGroup"
                                :last-page="questionsGroups.length"
                                :from="shownQuestionsFrom"
                                :to="shownQuestionsTo"
                                :total="questions.length"
                                :length="questions.length"
                                @changePage="changePage"
                            )
                            .play-box__buttons(v-if="areQuestionsShown")
                                cs-button.play-box__button(
                                    color="blue"
                                    @click='processReply'
                                    :disabled="!allAnswersSelected"
                                ) {{ $i18n.t('trainer.trainer_gamePlayBox_reply') }}

                .play-box__end-container(v-if="gameFinished && !isOlympiad")
                    fireworks(:is-mobile="isMobile")
                    .play-box__reaction-container
                        .play-box__answers-container
                            .play-box__answers.play-box__answers--good
                                | {{ $i18n.t('trainer.trainer_gamePlayBox_correct') }}
                                br
                                | {{ answer.good }}
                            .play-box__answers.play-box__answers--bad
                                | {{ $i18n.t('trainer.trainer_gamePlayBox_wrong') }}
                                br
                                | {{ answer.bad }}
                        .play-box__answers.play-box__answers--good.play-box__answers--show-md
                            | {{ $i18n.t('trainer.trainer_gamePlayBox_correct') }}
                            br
                            | {{ answer.good }}
                        result-image.play-box__image(status="success")
                        .play-box__answers.play-box__answers--bad.play-box__answers--show-md
                            | {{ $i18n.t('trainer.trainer_gamePlayBox_wrong') }}
                            br
                            | {{ answer.bad }}
                    result-buttons(
                        :exercise-id="exerciseId"
                        :games-type="parameters.courseType"
                        show-restart-button
                        @restartGame="restartGame"
                    )
                        slot
        cs-loader(v-else)
</template>

<script>
    /*eslint-disable*/
    import _ from 'lodash';
    import ScalingBar from './ScalingBar.vue'
    import playBoxGameMixin from '../../../../utils/trainer/playBoxGameMixin.js';
    import olympiadAnswerTimerMixin from '../../../../utils/olympiads/olympiadAnswerTimerMixin.js';
    import IntervalConfig from "../../configs/IntervalConfig";
    import metronome from '../../../../utils/trainer/metronome.js'
    import GamePreparationCounter from '../../GamePreparationCounter.vue'
    import Pagination from '../../../lists/Pagination.vue'

    const EMPTY_PLACE = "___";
    const FULL_SENTENCE_MODE = 'all';
    const APPEAR_MODE = 'appear';
    const DISAPPEAR_MODE = 'disappear';
    const STATIC_MODE = 'static';
    const DEFAULT_VOLUME = 0.6;
    const MIRROR_TYPE_FORMATTING = 'mirrorText';
    const ANAGRAMS_TYPE_FORMATTING = 'anagrams';
    const REMOVE_END_LETTERS_MODE = 'end';
    const REMOVE_CENTRAL_LETTERS_MODE = 'center';
    const AMOUNT_OF_QUESTIONS = 3;
    const IMMUTABLE_SYMBOLS = ['-', '—', '\n', '\r'];
    const SECONDS_IN_MINUTE = 60;
    function DEFAULT_DATA () {
        return {
            fontSize: 20,
            textBox: null,
            testTextBox: null,
            text: "",
            questions: [],
            textElements: [],
            areQuestionsShown: false,
            gameAnswers: [],
            isGameTuned: false,
            dynamicGameInterval: null,
            answer: {
                good: 0,
                bad: 0
            },
            maxOneLineTextWidth: 0,
            shownGroup: 1,
            statistics: {
                readingSpeed: null,
                understandingSpeed: null,
            },
        }
    }

    export default {
        mixins: [playBoxGameMixin, olympiadAnswerTimerMixin, metronome],
        components: {
            Pagination,
            GamePreparationCounter,
            ScalingBar,
        },
        data () {
            return Object.assign({
                availableSpeed: IntervalConfig.secondsForShutter,
            }, DEFAULT_DATA())
        },
        computed: {
            allAnswersSelected () {
                return this.gameAnswers.length === this.questions.length;
            },
            textLabel () {
                return this.parameters.textLabel.replace(/\([^)]+\)/, '').replace('&nbsp;', '')
            },
            isSlowDownAvailable () {
                return this.isGameTuned && !this.areQuestionsShown
                        && !this.isOlympiad
                        && this.parameters && this.parameters.mode !== STATIC_MODE
                        && this.parameters.speed.showTime !== this.availableSpeed[this.availableSpeed.length - 1];
            },
            textContainerStyle () {
                if (this.parameters && this.parameters.settings.solidText && this.maxOneLineTextWidth) {
                    return {'max-width': `${this.maxOneLineTextWidth}px`};
                }
                return '';
            },
            questionsGroups() {
                return _.chunk(this.questions, AMOUNT_OF_QUESTIONS);
            },
            shownQuestionsFrom() {
                return this.shownGroup === 1 ? 1 : (this.shownGroup - 1) * AMOUNT_OF_QUESTIONS;
            },
            shownQuestionsTo() {
                let numberOfQuestionsToShow = this.shownGroup * AMOUNT_OF_QUESTIONS;
                return numberOfQuestionsToShow > this.questions.length ? this.questions.length : numberOfQuestionsToShow;
            }
        },
        methods: {
            changePage(page) {
                switch (page) {
                    case 'next':
                        this.shownGroup !== this.questionsGroups.length && this.shownGroup++;
                        break;
                    case 'prev':
                        this.shownGroup !== 1 && this.shownGroup--;
                        break;
                    default:
                        this.shownGroup = page;
                        break;
                }
            },
            fetchData () {
                this.getExercise()
                .then(() => {
                    this.text = _.cloneDeep(_.trim(this.parameters.sourceText));
                    if (!this.text[this.text.length - 1].match(/[.!?]+/g)) {
                        this.text += '.';
                    }
                    if (this.parameters.settings.allQuestions || this.parameters.questions.length < AMOUNT_OF_QUESTIONS) {
                        this.questions = this.parameters.questions;
                    } else {
                        this.questions = _.shuffle(this.parameters.questions).splice(0, AMOUNT_OF_QUESTIONS);
                    }
                    this.prepareGame(this.parameters.mode);
                    this.isLoading = false;
                })
                .catch(e => {
                    this.isLoading = false;
                    this.$toasted.error(this.$root.$t('errors.getting_level'));
                    this.$router.push({ name: 'dashboard' });
                });
            },
            slowDownGame () {
                this.gameStarted = false;
                this.textElements = [];
                this.stopMetronome();
                if (this.timer) {
                    this.stopTimer();
                    this.timer = null;
                }
                if (this.dynamicGameInterval) {
                    clearInterval(this.dynamicGameInterval);
                }
                let oldSpeedIndex = this.availableSpeed.indexOf(+this.parameters.speed.showTime);
                let newSpeedIndex = this.availableSpeed.length - oldSpeedIndex >= 2 ? ++oldSpeedIndex : this.availableSpeed.length - 1;
                this.parameters.speed.showTime = this.availableSpeed[newSpeedIndex];
                this.parameters.speed.value = Math.round((this.parameters.settings.words / this.parameters.speed.showTime) * SECONDS_IN_MINUTE);
                this.counter = 0;
                this.runCounter();
            },
            processReply () {
                this.gameAnswers.forEach(item => item.answer.correct ? this.answer.good++ : this.answer.bad++);
                this.gameFinished = true;
                if (this.parameters.settings.allQuestions && !this.parameters.settings.solidText) {
                    this.statistics.understandingSpeed = Math.round((this.statistics.readingSpeed
                        * (this.answer.good / (this.answer.good + this.answer.bad))));
                    this.$toasted.info(
                        this.$i18n.t('trainer.trainer_gamePLayBox_understandingSpeed', {
                            speed: this.statistics.understandingSpeed
                        }),
                        {
                            duration: 5000,
                            position: 'top-center'
                        }
                    )
                }
                this.sendStat();
                if (!this.isOlympiad) {
                    this.soundInstance = this.$createjs.Sound.play("gameDone");
                    this.soundInstance.volume = DEFAULT_VOLUME;
                }
                document.removeEventListener('keydown', this.processReplyOnEnter);
            },
            prepareGame (mode) {
                let newLineIndices = [];
                let amountOfWordsBeforeNewLine = [];
                this.formatText();
                this.text.split('').forEach((char, index) => {
                    if (char === '\n' || char === '\r') {
                        amountOfWordsBeforeNewLine.push(this.text.slice(0, index).split(/\s/g).length);
                        newLineIndices.push(index);
                    }
                });
                let words = this.text.split(/\s/g).filter(word => !!word);
                let sentences = this.text.match(/[^\n.!?]+[.!?»]+/g);
                if (mode === STATIC_MODE) {
                    if (this.parameters.settings.endLetters) {
                        words = this.removeLettersFromWords(REMOVE_END_LETTERS_MODE, words);
                    }
                    if (this.parameters.settings.centralLetters) {
                        words = this.removeLettersFromWords(REMOVE_CENTRAL_LETTERS_MODE, words);
                    }
                    this.text = words.join(" ");
                    sentences = this.text.split(/\s/g).join(" ").match(/[^.!?]+[.!?"'»\]]+/g);
                    sentences = sentences.map(sentence => sentence.split(/\s/g).filter(word => !!word).join(" "));
                    if (this.parameters.settings.withoutWord) {
                        sentences = this.removeWordFromSentences(sentences);
                    }
                    if (this.parameters.settings.anagrams && this.parameters.settings.anagrams.mode) {
                        sentences = this.formatSentences(sentences, ANAGRAMS_TYPE_FORMATTING);
                    }
                    if (this.parameters.settings.mirrorText) {
                        sentences = this.formatSentences(sentences, MIRROR_TYPE_FORMATTING);
                    }
                    this.text = sentences.join(" ");
                    newLineIndices.forEach(index => this.text = this.text.slice(0, index) + "\n" + this.text.slice(index));
                    if (this.parameters.settings.endLetters) {
                        words = this.text.split(/\s/g);
                        this.text = words.join("  ");
                        newLineIndices.forEach((newLineIndex, index) => {
                            this.text = this.text.slice(0, newLineIndex + amountOfWordsBeforeNewLine[index] + index)
                                    + "\n" + this.text.slice(newLineIndex + amountOfWordsBeforeNewLine[index] + index)
                        });
                    }
                    if (this.parameters.settings.solidText) {
                        this.text = this.text.replace(/[\-—]*[^А-Яа-яёЁýá\-—\w]+/g, "").toLowerCase();
                        this.$nextTick(() => {
                            let playBox = document.querySelector('.play-box');
                            if (playBox) {
                                this.maxOneLineTextWidth = playBox.clientWidth;
                            }
                        });
                    }
                    if (this.parameters.settings.withoutVowels) {
                        this.text = this.text.replace(/[ауоыиэяюёеіaeioyАУОЫИЭЯЮЁЕІAEIOUY]+/g, "");
                    }
                } else if (mode === APPEAR_MODE && this.gameStarted) {
                    const HEADER_ELEMENT = '';
                    let array = [HEADER_ELEMENT, ..._.chunk(words, this.parameters.settings.words).map(chunk => chunk.join(' ') + ' ')];
                    this.textElements.push(array[0]);
                    this.generateTextElements((index) => {
                        if (index === array.length) {
                            clearInterval(this.dynamicGameInterval);
                            this.showQuestions();
                        }
                        if (index === 0) {
                            this.$refs['text-header'].classList.add('game-text_hidden')
                        }
                        this.textElements.splice(0, 1, array[index]);
                    }, mode);
                } else if (mode === DISAPPEAR_MODE && this.gameStarted) {
                    const HEADER_ELEMENT = { id: 0, content: '', enabled: true };
                    this.textElements = _.chunk(words, this.parameters.settings.words).map(chunk => chunk.join(' ') + ' ');
                    this.textElements = [
                        HEADER_ELEMENT,
                        ...this.textElements.map((el, index) => ({ id: index + 1, content: el, enabled: true }))
                    ];
                    if (this.textElements.length) {
                        this.generateTextElements((index) => {
                            if (index === 0) {
                                this.$refs['text-header'].classList.add('game-text_hidden');
                            }
                            this.textElements[index++].enabled = false;
                            if (index === this.textElements.length) {
                                this.showQuestions();
                                clearInterval(this.dynamicGameInterval);
                            }
                        });
                    }
                }
            },
            formatText () {
                this.removeRepeatedWhitespaces();
                this.removeWhitespacesBeforeNewLines();
                this.removeRepeatedNewLines();
                this.addWhitespacesBeforeNewLines();
            },
            removeRepeatedWhitespaces () {
                let whitespacesRepeatedIndices = [];
                this.text.split('').forEach((char, index) =>
                        (char === ' '  && this.text[index-1].match(/\s/))
                        && whitespacesRepeatedIndices.push(index-1)
                )
                whitespacesRepeatedIndices.forEach((whitespaceIndex, index) =>
                        this.text = this.text.slice(0, whitespaceIndex - index) + this.text.slice(whitespaceIndex - index + 1));
            },
            removeWhitespacesBeforeNewLines () {
                let whitespacesBeforeNewLineIndices = [];
                this.text.split('').forEach((char, index) =>
                        ((char === '\n' || char === '\r') && this.text[index-1].match(/\s/))
                        && whitespacesBeforeNewLineIndices.push(index-1)
                )
                whitespacesBeforeNewLineIndices.forEach((whitespaceIndex, index) =>
                        this.text = this.text.slice(0, whitespaceIndex - index) + this.text.slice(whitespaceIndex - index + 1));
            },
            removeRepeatedNewLines () {
                let newLineRepeatedIndices = [];
                this.text.split('').forEach((char, index) =>
                        (char === '\n' || char === '\r') && (this.text[index-1] === "\r" || this.text[index-1] === "\n")
                        && newLineRepeatedIndices.push(index)
                )
                newLineRepeatedIndices.forEach((newLineIndex, index) =>
                        this.text = this.text.slice(0, newLineIndex - index) + this.text.slice(newLineIndex - index + 1));
            },
            addWhitespacesBeforeNewLines() {
                let whitespacesBeforeNewLineIndices = [];
                this.text.split('').forEach((char, index) =>
                        ((char === '\n' || char === '\r') && !this.text[index-1].match(/\s/))
                        && whitespacesBeforeNewLineIndices.push(index)
                )
                whitespacesBeforeNewLineIndices.forEach((index, i) =>
                        this.text = this.text.slice(0, index + i) + " " + this.text.slice(index + i))
            },
            formatSentences (sentences, typeOfFormatting) {
                return sentences.map(sentence => {
                    let sentenceWords = sentence.split(/\s/g);
                    if (sentence.substring(0, sentence.length - 1).match(/^[0-9,()]+$/)) {
                        return sentence;
                    }
                    sentenceWords = sentenceWords.filter(word => !!word);
                    let specialElements = sentenceWords.filter(word => !word || word[0] === "_" || IMMUTABLE_SYMBOLS.includes(word));
                    if (this.parameters.settings[typeOfFormatting].mode !== FULL_SENTENCE_MODE
                            && sentenceWords.length - specialElements.length > this.parameters.settings[typeOfFormatting].mode) {
                        let indices = [];
                        let randomWords = [];
                        while (!randomWords.length
                                || !randomWords.every(word => word && word[0] !== "_" && !IMMUTABLE_SYMBOLS.includes(word))
                                ) {
                            randomWords = this.getRandomWords(sentenceWords, this.parameters.settings[typeOfFormatting].mode, typeOfFormatting);
                            indices = randomWords.map(word => sentenceWords.indexOf(word));
                        }
                        randomWords = randomWords.map(word => this[typeOfFormatting](word));
                        for (let i = 0; i < indices.length; i++) {
                            sentenceWords[indices[i]] = randomWords[i];
                        }
                    } else {
                        sentenceWords = sentenceWords.map(word => this[typeOfFormatting](word));
                    }
                    return sentenceWords.join(" ");
                });
            },
            countWordsInText (text) {
                return text.trim().replace(/[().,\/\s]+/gi,' ').trim().split(' ').length;
            },
            showQuestions () {
                if (!this.parameters.settings.solidText) {
                    this.statistics.readingSpeed = Math.round(((this.countWordsInText(this.text)
                        + this.countWordsInText(this.textLabel)) * 60 / this.time));
                    if (this.parameters.mode === 'static') {
                        this.$toasted.info(
                            this.$i18n.t('trainer.trainer_gamePLayBox_ReadingSpeed', {
                                speed: this.statistics.readingSpeed
                            }),
                            {
                                duration: 5000,
                                position: 'top-center'
                            }
                        )
                    }
                }
                this.stopMetronome();
                if (this.answerDuration) {
                    this.startAnswerTimer();
                }
                for (let i = 0; i < this.questions.length; i++) {
                    let answers = this.questions[i].answers;
                    for (let j = 0; j < answers.length; j++) {
                        answers[j].selected = false;
                    }
                }
                this.areQuestionsShown = true;
                if (!this.answerDuration) {
                    this.stopTimer();
                }
                document.removeEventListener('keydown', this.readTextOnEnter);
            },
            setAnswer (answer, id) {
                id = this.shownGroup === 1 ? id : (this.shownGroup * AMOUNT_OF_QUESTIONS - AMOUNT_OF_QUESTIONS) + id;
                this.questions[id].answers.forEach(answer => answer.selected = false);
                answer.selected = true;
                let exists = this.gameAnswers.length && this.gameAnswers.find(answer => answer.id === id);
                exists && this.gameAnswers.splice(_.indexOf(this.gameAnswers, exists), 1);
                this.gameAnswers.push({id: id, answer: answer});
                this.allAnswersSelected && document.addEventListener('keydown', this.processReplyOnEnter);
            },
            generateTextElements (cb) {
                let index = 0;
                this.dynamicGameInterval = setInterval(() => {
                    cb && cb(index++);
                }, this.parameters.speed.showTime * 1000);
            },
            mirrorText (word) {
                let letters = word.replace(/\(([^)(]+)\)/g, ")$1(").split("");
                let separator = word.match(/[.,:;!?»]+/g);
                let openingSymbol = word.match(/«/g);
                if (openingSymbol) {
                    letters = letters.concat(letters.splice(0, openingSymbol[0].length));
                }
                if (separator) {
                    letters.length = letters.length - separator[0].length;
                    letters.unshift(separator[0]);
                }
                return letters.reverse().join("");
            },
            removeLettersFromWords (mode, words) {
                let additiveChars = this.parameters.settings.letters === 2 ? EMPTY_PLACE.slice(0, 2) : EMPTY_PLACE.slice(0, 1);
                return words = words.map(word => {
                    let letters = word.split("");
                    let wordEndsWithSeparators = word.match(/[.,!?;:)}\]"'»]+/g);
                    let subtractedIndex = !wordEndsWithSeparators ? 0 : wordEndsWithSeparators[0].length;
                    if (word.length > 2 && !(wordEndsWithSeparators && word.length === 3)) {
                        if (mode === REMOVE_CENTRAL_LETTERS_MODE) {
                            if (word.length !== 3) {
                                letters.splice(letters.length / 2 - subtractedIndex, this.parameters.settings.letters, additiveChars);
                            } else {
                                letters.splice(letters.length / 2 - subtractedIndex, 1, EMPTY_PLACE.slice(0, 1));
                            }
                        } else {
                            letters.splice(-this.parameters.settings.letters - subtractedIndex, this.parameters.settings.letters, additiveChars);
                        }
                    }
                    return letters.join("");
                });
            },
            removeWordFromSentences (sentences) {
                return sentences.map(sentence => {
                    let sentenceWords = sentence.split(/\s/g);
                    sentenceWords = sentenceWords.filter(word => !!word);
                    if (sentenceWords.length > 2) {
                        let indexForDeleting = Math.round(sentenceWords.length / 2);
                        let wordForDeleting = !IMMUTABLE_SYMBOLS.includes(sentenceWords[indexForDeleting]) && sentenceWords[indexForDeleting].length >= 2
                                ? sentenceWords[indexForDeleting]
                                : sentenceWords[++indexForDeleting];
                        let separator = wordForDeleting.match(/[.,!?;:)}\]"'»]+/g);
                        let length = wordForDeleting.length + 1;
                        length -= separator ? separator[0].length : 0;
                        let emptyPlace = new Array(length).join('_');
                        emptyPlace += separator ? separator[0] : "";
                        sentenceWords.splice(indexForDeleting, 1, emptyPlace);
                    }
                    return sentenceWords.join(" ");
                });
            },
            getRandomWords (array, amount, typeOfFormatting) {
                if (typeOfFormatting === ANAGRAMS_TYPE_FORMATTING) {
                    array = array.filter(word => word.length > 2 && !this.isWordContainsDigits(word));
                }
                let result = new Array(amount),
                        len = array.length,
                        taken = new Array(len);
                amount > len && (amount = len);
                while (amount--) {
                    let x = Math.floor(Math.random() * len);
                    result[amount] = array[x in taken ? taken[x] : x];
                    taken[x] = --len in taken ? taken[len] : len;
                }
                return result;
            },
            anagrams (word) {
                if (word.length < 2 || word[0] === "_" || word.match(/^[0-9,()-]+$/)) {
                    return word;
                }
                let char;
                if ((char = word.match(/[(){}\[\]"'»«_,.!?:;\-]/g))) {
                    let indices = [];
                    char.forEach(symbol => indices.push(word.indexOf(symbol)));
                    let partsOfWord = word.match(/[a-zA-Zа-яА-ЯёЁýá]+/g);
                    partsOfWord = partsOfWord.map(part => {
                        if (part.length > 2) {
                            return this.makeAnagram(part)
                        }
                        return part;
                    });
                    word = partsOfWord.join("");
                    for (let i = 0; i < char.length; i++) {
                        word = word.slice(0, indices[i]) + char[i] + word.slice(indices[i]);
                    }
                    return word;
                }
                return this.makeAnagram(word);
            },
            makeAnagram (word) {
                let regexp = new RegExp(word[0], 'g');
                let matches = word.match(regexp);
                if (matches && matches.length === word.length) {
                    return word;
                }
                let newWord = word.split('').sort(() => { return 0.5 - Math.random() }).join('');
                return newWord !== word ? newWord : this.makeAnagram(word);
            },
            refreshGameStatBeforeSend () {
                this.gameStat.attempts = 1;
                this.gameStat.answers = this.answer.good;
                this.gameStat.percent = this.calculatePercent();
                this.gameStat.statistics = this.statistics;
                this.gameStat.isCompleted = this.gameFinished;
                this.gameStat.executionTime = this.time;
                this.gameStat.isCorrect = true;
                this.gameStat.parameters = _.cloneDeep(this.parameters);
            },
            calculatePercent () {
                let total = this.questions.length;
                if (total > 0) {
                    return parseInt(this.answer.good / (total) * 100);
                }
                return 0;
            },
            beforeStart () {
                this.startMetronome();
                this.startGame();
            },
            startGame () {
                this.gameStarted = true;
                this.$nextTick(() => {
                    window.scrollTo(0, 0);
                });
                document.addEventListener('keydown', this.readTextOnEnter);
                !this.timer && this.setTimer();
                this.$nextTick(() => {
                    this.textBox = document.querySelector('.texts-game-container__interactive-place__main-box');
                    this.textBox && (this.textBox.style.fontSize = this.fontSize + 'px');
                    this.parameters.mode !== STATIC_MODE && (this.prepareGame(this.parameters.mode));
                });
            },
            lines (text) {
                return text.split('\n');
            },
            doneWithPreparing () {
                this.isGameTuned = true;
                this.gameBoxName = 'texts-game-container__interactive-place__main-box';
                this.isLoading = true;
                this.registerSounds();
            },
            readTextOnEnter (event) {
                event.keyCode === 13 && this.showQuestions();
            },
            processReplyOnEnter (event) {
                event.keyCode === 13 && this.processReply();
            },
            setFontSize (fontSize) {
                this.fontSize = fontSize;
            },
            beforeGameRestart() {
                Object.assign(this, DEFAULT_DATA());
            },
            isWordContainsDigits (word) {
                return /\d/.test(word);
            }
        },
        beforeDestroy () {
            clearInterval(this.dynamicGameInterval);
            document.removeEventListener('keydown', this.readTextOnEnter);
            document.removeEventListener('keydown', this.processReplyOnEnter);
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/sass/games/playbox.scss";

    .play-box__game {
        display: flex;
        flex: 1 1 auto;
        flex-direction: column-reverse;
        @include media($lg) {
            flex-direction: row;
        }
    }

    .play-box__example {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-grow: 5;
        flex-direction: column;
    }

    .play-box__example--answers {
        align-items: flex-start;
    }

    .play-box__overflow-container {
        overflow-y: auto;
        height: 100%;
        @include scrollbar;
    }

    .play-box__field {
        padding: 0 20px;
        text-align: center;
        font-size: 20px;
        user-select: none;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        flex-direction: column;
    }

    .play-box__field-bottom-container {
        display: flex;
        align-items: baseline;
        flex: 1 1 auto;
    }

    .play-box__field_one-lined-text {
        overflow-wrap: break-word;
    }

    .play-box__field--answers {
        padding: 0;
        align-items: flex-start;
        justify-content: flex-start;
    }

    .play-box__field--appear-mode {
        display: flex;
        align-items: center;
        justify-content: center;
        //height: 72vh;
        text-indent: 0;
    }
    .play-box__field--inverted-text {
        transform: rotate(180deg);
        text-align: center;
    }

    .play-box__word {
        padding: 10px;
        margin: 0 10px 10px 0;
        background: $x-color-white;
        border-radius: $border-radius-5;

        word-break: break-all;

        cursor: pointer;
    }

    .play-box__word:last-child {
        margin-right: 0;
    }

    .play-box__word--selected {
        color: $x-color-white;
        background: $hsl-color-green-58;
    }

    .play-box__word--unselected {
        color: $x-color-white;
        background: $hsl-color-red-62;
    }

    .play-box__header {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-weight: 500;
        margin-top: -5px;
        @include media($sm) {
            margin-bottom: 10px;
        }
    }

    .play-box__title {
        font-size: 22px;
        line-height: 26px;
        @include media($md) {
            font-size: 32px;
            line-height: 38px;
        }
    }

    .game-text {
        opacity: 1;
        transition: opacity 0.5s ease;
    }
    .game-text_hidden {
        opacity: 0;
    }

    .play-box__question:not(:last-child) {
        margin-bottom: 40px;
    }

    .question__content {
        font-weight: 500;
        font-size: 18px;
        line-height: 21px;
        margin-bottom: 20px;
        text-align: left;
    }

    .question__answer {
        font-size: 16px;
        line-height: 19px;
    }

    .play-box__end-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
    }

    .play-box__reaction-container {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;
    }

    .play-box__time {
        font-weight: 500;
        font-size: 32px;
        line-height: 38px;
        text-align: center;
        color: $hsl-color-green-58;
        margin-bottom: 30px;
    }

    .play-box__end-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
    }

    .play-box__reaction-container {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;
        @include media($md) {
            flex-direction: row;
        }
    }

    .play-box__answers {
        font-weight: 500;
        font-size: 18px;
        line-height: 21px;
        text-align: center;
        @include media($md) {
            font-size: 22px;
            line-height: 26px;
        }
        @include media($lg) {
            font-size: 32px;
            line-height: 38px;
        }
        @include media($xl) {
            font-size: 42px;
            line-height: 50px;
        }
    }

    .play-box__answers--bad {
        color: $hsl-color-red-62;
        @include media($md) {
            margin-left: 20px;
        }
        @include media($lg) {
            margin-left: 35px;
        }
    }

    .play-box__answers--good {
        color: $hsl-color-green-58;
        @include media($md) {
            margin-right: 20px;
        }
        @include media($lg) {
            margin-right: 35px;
        }
    }

    .play-box__answers--show-md {
        display: none;
        @include media($md) {
            display: block;
        }
    }

    .play-box__answers-container {
        display: flex;
        width: 100%;
        justify-content: space-between;
        @include media($md) {
            display: none;
        }
    }

    .play-box__image {
        max-width: 100%;
        margin-bottom: 30px;
        @include media($md) {
            margin-bottom: 40px;
        }
    }

    .play-box__buttons {
        display: flex;
        flex-direction: column;
        margin: 20px 0 0 35px;
        @include media($sm) {
            margin-top: 25px;
        }
        @include media($lg) {
            flex-direction: row;
        }
    }

    .play-box__buttons--game {
        margin: 0 0 10px;
        @include media($sm) {
            margin: 0 0 15px;
        }
    }

    .play-box__button {
        margin: 20px 0;
        @include media($lg) {
            margin: 0 20px;
        }
    }

    .play-box__button:first-child {
        margin-top: 0;
        @include media($lg) {
            margin-left: 0;
        }
    }

    .play-box__button:last-child {
        margin-bottom: 0;
        @include media($lg) {
            margin-right: 0;
        }
    }

    .play-box__game-info {
        align-self: flex-end;
        @include media($md) {
            align-self: auto;
        }
    }

    .warning {
        display: table-cell;
        vertical-align: middle;
        text-align: center;
    }
</style>
